export default __webpack_public_path__ + "static/media/medicine-cases-icon.6de68ad8.svg";